import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { Days } from 'src/app/core/models/operations/operations-scheduled-pickup.model';

@Component({
  selector: 'app-days-assigned',
  templateUrl: './days-assigned.component.html',
  styleUrls: ['./days-assigned.component.scss'],
  standalone: false,
})
export class DaysAssignedComponent implements OnChanges {
  @Input()
  data!: Days;

  @Input()
  disabled?: boolean = false;

  @Output()
  updateAvailabilityEvent = new EventEmitter();

  objectKeys!: { (o: object): string[]; (o: object): string[] };
  //FIX TYPES
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  days!: any;
  daysAssigned: Days = {
    sunday: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
  };

  ngOnChanges() {
    const daysAssigned = this.data === null ? this.daysAssigned : this.data;

    this.days = {
      data: [
        { day: 'Su', value: daysAssigned.sunday },
        { day: 'Mo', value: daysAssigned.monday },
        { day: 'Tu', value: daysAssigned.tuesday },
        { day: 'We', value: daysAssigned.wednesday },
        { day: 'Th', value: daysAssigned.thursday },
        { day: 'Fr', value: daysAssigned.friday },
        { day: 'Sa', value: daysAssigned.saturday },
      ],
    };
    this.assignValues(daysAssigned);
  }

  assignValues(daysAssigned: Days) {
    this.daysAssigned.sunday = daysAssigned.sunday;
    this.daysAssigned.monday = daysAssigned.monday;
    this.daysAssigned.tuesday = daysAssigned.tuesday;
    this.daysAssigned.wednesday = daysAssigned.wednesday;
    this.daysAssigned.thursday = daysAssigned.thursday;
    this.daysAssigned.friday = daysAssigned.friday;
    this.daysAssigned.saturday = daysAssigned.saturday;
  }

  changeAvailability(dayObject: { day: string; value: boolean }) {
    this.days.data.forEach((item: { day: string; value: boolean }) => {
      if (item.day === dayObject.day) {
        item.value = !dayObject.value;
      }
    });
    this.daysAssigned.sunday = this.days.data[0].value;
    this.daysAssigned.monday = this.days.data[1].value;
    this.daysAssigned.tuesday = this.days.data[2].value;
    this.daysAssigned.wednesday = this.days.data[3].value;
    this.daysAssigned.thursday = this.days.data[4].value;
    this.daysAssigned.friday = this.days.data[5].value;
    this.daysAssigned.saturday = this.days.data[6].value;

    if (!this.disabled) {
      this.updateAvailabilityEvent.emit(this.daysAssigned);
    } else {
      // Setting back to all false
      this.updateAvailabilityEvent.emit(this.data);
    }
  }

  getKeys(days: any) {
    return days ? Object.keys(days) : [];
  }
}
